import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { Publication } from 'types/publication'
import { createStandardAction } from 'typesafe-actions'

export const updateAgeFilter = createStandardAction('filter/set/age')<
  Age | undefined
>()
export const updateGenderFilter = createStandardAction('filter/set/gender')<
  Gender | undefined
>()
export const updatePublicationFilter = createStandardAction(
  'filter/set/publication'
)<Publication | undefined>()

export const updateEducationFilter = createStandardAction(
  'filter/set/education'
)<Education | undefined>()

export const clearFilter = createStandardAction('filter/unset')()
